package util

import kotlinx.browser.document
import org.w3c.dom.HTMLElement

object DebugManager {
    val DEBUG_ENABLED = document.cookie.contains("debug=true", ignoreCase = true)

    private val data = arrayListOf<String>()
    private val container = (document.createElement("div") as HTMLElement).apply {
        style.apply {
            position = "fixed"
            top = "0"
            left = "100px"
            padding = "0.5em"
//            backgroundColor = "rgba(0, 0, 0, 0.5)"
            color = "white"
            fontFamily = "monospace"
            fontSize = "12px"
            zIndex = "1000"
        }

        document.body!!.appendChild(this)
    }

    private val element = document.createElement("pre").apply {
        container.appendChild(this)
    }

    /**
     * Should be called *once* at the end of a render loop to display the data. Clears the data afterwards.
     */
    fun render() {
        if (!DEBUG_ENABLED) return

        element.textContent = data.joinToString("\n")
        data.clear()
    }

    /**
     * Add a debug message to the data. Should not change order between frames to make it easier to read.
     */
    fun debug(message: String) {
        if (DEBUG_ENABLED) data.add(message)
    }
}